<template>
    <div class="row">
        <div class="col-md-12">
            <div class="row m-2">
                <div class="col-md-3">
                    <div class="card card-memory">
                        <div class="card-body">
                            <div class="data-circle text-center">
                                <div class="circle-content">
                                    <span class="fw-bold">{{ memory_used }} Used</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-9" v-if="foldersForBackup.length > 0 ">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="form-group">
                                        <label for="" class="form-label">Select Folders To Include in backup</label>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-2" v-for="(folder, index) in foldersForBackup" :key="index">
                                            <label class="form-label"> 
                                                {{  folder[0].toUpperCase() + folder.slice(1) }} 
                                            </label>
                                            <br>
                                            <label class="switch">
                                                <input id="backup-folder" type="checkbox" v-model="backup_folders" :value="folder">
                                                <span class="switch__slider"></span>
                                            </label>  
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="row mt-5">
                                        <div class="col-md-12">
                                            <div class="d-flex justify-content-center align-items-center">
                                                <button type="submit" class="button" @click="generateBackup('project')">Generate Backup</button>
                                            </div>
                                        </div>
                                    </div> 
                                    <div class="row mt-2">
                                        <div class="col-md-12">
                                            <div class="d-flex justify-content-center align-items-center">
                                                <button type="submit" class="button" @click="generateBackup('database')">Generate Database Backup</button>
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                            <div class="row mt-4" v-if="successMessage">
                                <div class="col-md-12">
                                    <div class="alert alert-success" role="alert">
                                        {{ successMessage }}
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-4" v-else-if="selected_option_error">
                                <div class="col-md-12">
                                    <div class="alert alert-danger" role="alert">
                                        {{ selected_option_error }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-12">
                    <div class="box">
                        <div class="row">
                            <div class="col-md-12 m-3">
                                <h3> Backup Management </h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <table class="table table-striped table-inverse table-responsive">
                                    <thead class="thead-inverse">
                                        <tr>
                                            <th>Name</th>
                                            <th>Size</th>
                                            <th>Backup Date</th>
                                            <th>Action</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="backupList.length > 0 ">
                                                <tr v-for="{backup_name,backup_size,backup_date, id} in backupList" :key="id">
                                                    <td>
                                                        <a href="javascript:void(0)" class="color-orange" @click="downloadBackup(id, backup_name)">
                                                            {{ backup_name }}
                                                        </a>
                                                    </td>
                                                    <td>{{ backup_size }}</td>
                                                    <td>{{ backup_date }}</td>
                                                    <td>
                                                        <a class="btn btn-primary" target="_blank" @click="downloadBackup(id, backup_name)" role="button" >
                                                            Download
                                                        </a>
                                                        &nbsp;
                                                        <a class="btn btn-danger" href="javascript:void(0)" role="button" @click="deteteBackup(id,backup_name)">
                                                            Delete
                                                        </a>
                                                    </td>
                                                </tr>
                                            </template>
                                            <template v-else><tr class="text-center"><td colspan="4">No Backups Found</td></tr></template>
                                        </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DatabaseBackups',
    data () {
        return {
            backupList: [],
            memory_used: '0 KB',
            backup_folders:[],
            foldersForBackup: [],
            successMessage: "",
            selected_option_error: null
        }
    },
    mounted() {
        this.getBackupList()
    },
    methods: {
        getBackupList() {
            this.$store.dispatch('setLoadStatus')
            fetch(`${this.$api}get-backups`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                if (response.status) {
                    this.backupList = response.data
                    this.memory_used = response.storage_size
                    this.foldersForBackup = response.folders
                }
                this.$store.dispatch('setLoadStatus')
            });
        },
        generateBackup(type) {
            if (type == 'project') {
                if (this.backup_folders.length == 0 ) {
                    this.selected_option_error = "Please select any one option"
                    return false;
                }
            }

            this.selected_option_error = ""

            this.$store.dispatch('setLoadStatus')
            fetch(`${this.$api}create-backups`, {
                method: 'POST',
                body: JSON.stringify({
                    backup_type: type,
                    selected_option: this.selected_option,
                    filename: this.backup_name,
                    backup_folders:this.backup_folders
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                if (response.status) {
                    this.successMessage = response.message
                    setTimeout(() => {
                        this.successMessage = ""
                    }, 3000);
                    this.backup_folders = []
                    this.getBackupList()
                }
                this.$store.dispatch('setLoadStatus')
            });
        },
        async downloadBackup(backup_id, backup_name) {
            this.$store.dispatch('setLoadStatus')
            fetch(`${this.$api}download-backup?id=${backup_id}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then((res) => {
                if(res.status === 200) {
                    res.blob().then(response => {
                        const _url = window.URL.createObjectURL(response)
                        const link = document.createElement('a')
                        link.href = _url
                        link.setAttribute('download',backup_name)
                        document.body.appendChild(link)
                        link.click();
                        this.$store.dispatch('setLoadStatus')
                    })
                    
                } else {
                    this.$store.dispatch('setLoadStatus')
                    Promise.race([res.json()])
                    .then(response => {
                    if(response.message) {
                        this.$notify({
                        type: 'error',
                        title: response.message
                        });
                    } else {
                        this.$notify({
                        type: 'error',
                        title: response.error
                        });
                    }
                    })
                }
            });
        },
        deteteBackup(id,path) {
            this.$dialog
                .confirm(`Are you sure you want to delete theis backup ?`)
                .then(() => {
                    this.$store.dispatch('setLoadStatus')
                    fetch(`${this.$api}delete-backup`, {
                        method: 'POST',
                        body: JSON.stringify({
                            backup_id:id,
                            filename: path
                        }),
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'Authorization': localStorage.getItem('token')
                        }
                    })
                        .then(res => res.json())
                        .then(response => {
                            if (response.status) {
                                this.$notify({
                                    type: 'success',
                                    title: response.message
                                });
                                this.getBackupList()
                            }
                            this.$store.dispatch('setLoadStatus')
                        });
                })
        },
        setBackupFolders() {
            console.log(this.selected_folder);

            
        }
    }
}
</script>

<style lang="scss" scoped>
.card {
    border-radius: 15px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}
.card-memory {
    width: auto;
    height: 150px;
}
.data-circle {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background-color: #f8f9fa;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0px auto;
    background-color: #e1f5e1;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}
.circle-content {
    text-align: center;
    word-wrap: break-word;
    overflow-wrap: break-word;
    max-width: 100%;
}

</style>